import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import { useQueryRequest } from './QueryRequestProvider'
import { FornecedorList } from '../../core/_models'
import { getFornecedores } from '../../core/_requests'
import {
  createResponseContext,
  initialQueryResponse,
  WithChildren,
  stringifyRequestQuery,
  QUERIES,
} from '_metronic/helpers'
import { useModal } from 'app/components'

const QueryResponseContext = createResponseContext<FornecedorList>(initialQueryResponse)

export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()
  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery([QUERIES.FORNECEDORES_LIST, query, isOpen], () => getFornecedores(query), {
    cacheTime: 0,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    enabled: !isOpen,
  })

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
